import dayjs from "dayjs";
import { Calendar, dayjsLocalizer, SlotInfo } from "react-big-calendar";
import { View } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import ManageSurveyAppointment from "./ManageSurveyAppointment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Alery from "./Alert";
import { useDispatch } from "react-redux";
import {
  getSurveyDiaryAction,
  setAddSurveyDiaryResponse,
  setUpdateSurveyDiaryResponse,
} from "../../../store/reducers/surveyDiarySlice";

const BasicSurveyDiary = () => {
  const localizer = dayjsLocalizer(dayjs);
  const dispatch = useDispatch();

  const { user,userProfile } = useSelector((state: any) => state?.user);

  const [open, setOpen] = useState<boolean>(false); // State variable to manage dialog open/close
  const [selectedSurvey, setSelectedSurvey] = useState<string>("");
  const [selectedDate, setSelectedDate] = useState<Date | null>(null); // State to store selected date
  const [openAlert, setOpenAlert] = useState<boolean>(false);

  const { surveyDiaryData, isSurveyDiarySuccess, isSurveyDiaryUpdateSuccess } =
    useSelector((state: any) => state?.surveyDiary);

  const [leadDetails, setLeadDetails] = useState<any>(null);
  useEffect(() => {
    setLeadDetails(
      sessionStorage.getItem("leadDetails")
        ? JSON.parse(sessionStorage.getItem("leadDetails") ?? "")
        : ""
    );
  }, []);
  useEffect(() => {
    dispatch(getSurveyDiaryAction());
  }, []);

  useEffect(() => {
    if (isSurveyDiarySuccess || isSurveyDiaryUpdateSuccess) {
      dispatch(getSurveyDiaryAction());
      dispatch(setAddSurveyDiaryResponse(false));
      dispatch(setUpdateSurveyDiaryResponse(false));
    }
  }, [isSurveyDiarySuccess, isSurveyDiaryUpdateSuccess]);

  const handleOpen = (event?: any) => {
    if (leadDetails && leadDetails?.lead?.generated_id) {
      if (!event?.id && surveyDiaryData) {
        // Initialize the survey variable to store the found survey
        let foundSurvey = null;

        surveyDiaryData.forEach((event: any) => {
          if (event?.id === leadDetails?.lead?.survey_id) {
            foundSurvey = event?.id; // Store the matched survey event
          } else if (event?.leadId === leadDetails?.lead?.generated_id) {
            foundSurvey = event?.id; // Store the matched survey event
          }
        });

        if (foundSurvey) {
          setSelectedSurvey(foundSurvey);
        }
      }
      setOpen(true);
    } else if (!leadDetails && !leadDetails?.lead?.generated_id && event?.id) {
      setOpen(true);
    } else {
      setOpenAlert(true);
    }
  };
  const handleClose = () => {
    setOpen(false);
    setSelectedSurvey("");
    setSelectedDate(null); // Reset selected date when closing
  };

  const handleSelectEvent = (event: any) => {
    setSelectedSurvey(event?.id);
    handleOpen(event);
  };

  const handleSelectSlot = (slotInfo: SlotInfo) => {
    setSelectedDate(slotInfo.start); // Set the selected date
    handleOpen(); // Open the modal
  };

  // Transform the surveyDiaryData to fit the calendar events format
  const transformedEvents = surveyDiaryData.map((event: any) => ({
    id: event.id,
    title: `${event.survey_type} || ${event?.customerName} || ${event?.surveyorName} `, // Set the title of the event
    start: new Date(event.start_time), // Convert start_time to Date object
    end: new Date(event.end_time), // Convert end_time to Date object
    allDay: false, // Adjust as needed
    description: event.description,
    status: event.status,
    // customerName: event.customerName,
  }));

  const currentDate = new Date();

  // Custom event component to show time in the month view
  const EventComponent = ({ event }: any) => (
    <span>
      <span style={{ fontSize: "14px" }}>
        {dayjs(event.start).format("h:mm A")} -{" "}
        {dayjs(event.end).format("h:mm A")}
      </span>
      <br /> {event.title}
    </span>
  );

  const [view, setView] = useState<View>("day");

  const formats = {
  agendaHeaderFormat: ({ start, end }: { start: Date; end: Date }) =>
    `${dayjs(start).format(userProfile?.dateFormat ? userProfile?.dateFormat : "DD/MM/YYYY")} - ${dayjs(end).format(userProfile?.dateFormat ? userProfile?.dateFormat : "DD/MM/YYYY")}`,
};

  return (
    <>
      {(user?.user?.roles?.includes("TENANT") ||
        user?.user?.roles?.includes("Admin") ||
        user?.user?.roles?.includes("Owner")) && (
        <Alery
          open={openAlert}
          alertModalShow={openAlert}
          setAlertModelShow={setOpenAlert}
          onHide={handleClose}
        />
      )}
      <ManageSurveyAppointment
        selectedSurvey={selectedSurvey}
        selectedDate={selectedDate} // Pass the selected date to the modal
        open={open}
        onHide={handleClose}
        title="Enter Survey Details"
        isReassignAction={false}
      />
      {/* <MyCalendar/> */}
      <Calendar
        localizer={localizer}
        events={transformedEvents ? transformedEvents : []}
        startAccessor="start"
        endAccessor="end"
        style={{ height: "100%", whiteSpace: "normal", maxHeight: "auto" }}
        onSelectEvent={handleSelectEvent}
        selectable={true} // Enable date slot selection
        onSelectSlot={handleSelectSlot} // Handle date slot selection
        step={60} // Defines each time slot as 30 minutes
        timeslots={1} // Defines two 30-minute slots per hour
        formats={formats}
        view={view}
        onView={(newView) => setView(newView)} // Update view state when calendar view changes
        defaultDate={currentDate} // Set the date state
        min={
          new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate(),
            0,
            0,
            0
          )
        } // Midnight
        max={
          new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate(),
            23,
            59,
            59
          )
        } // 11:59 PM
        scrollToTime={
          new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate(),
            7,
            0,
            0
          )
        } // Scroll to 7 AM
        eventPropGetter={(event) => ({
          style: {
            whiteSpace: "wrap !important",
            minHeight: "auto",
            height: "auto",
            backgroundColor:
              event.status === "PENDING"
                ? "#cc5500"
                : event.status === "INPROGRESS"
                ? "#add8e6"
                : event.status === "COMPLETED"
                ? "#008000 "
                : "#3174AD",
          },
        })}
        components={{
          event: view === "month" ? EventComponent : undefined, // Use custom event component to display time in month view
        }}
      />
    </>
  );
};

export default BasicSurveyDiary;
